import { type OpportunityReport } from "@entities";
import { Stack, Typography } from "@mui/material";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import { type CoreRow } from "@tanstack/react-table";
import HasPerformed from "../../../components/table/has-performed/HasPerformed";
import PhoneNumberCell from "../PhoneNumberCell";
import { ISSUE_TYPE_HEB } from "@shared/helpers/constants";
import { formatOpportunitySchedule } from "@shared/helpers/format-opportunity-schedule";

export const columns: ColumnProps<OpportunityReport>[] = [
  {
    field: "association.user.name",
    caption: "מתנדב/ת",
    cell: ({ row }: { row: CoreRow<OpportunityReport>; }) => {
      // @ts-ignore -- change caption
      return (
        <div>
          <Typography>
            <b>שם מלא</b> - {row.original.association?.user?.name}
          </Typography>
          <Stack direction="row" alignItems="center" gap={0.5} flexWrap="wrap">
            <Typography component="span">
              <b>מספר טלפון</b>:
            </Typography>
            <PhoneNumberCell
              phoneNumber={row.original.association?.user?.phoneNumber || ""}
            />
          </Stack>
        </div>
      );
    },
    enableSorting: false,
  },
  {
    field: "isGoalAchieved",
    caption: "האם בוצעה",
    cell: ({ row }: { row: CoreRow<OpportunityReport>; }) => {
      return <HasPerformed row={row} />;
    },
  },
  {
    field: "isNegativeExperience",
    caption: "חוויה חיובית",
    valueConverter: (row) => {
      return row.isNegativeExperience ? "לא" : "כן";
    },
  },
  {
    field: "issueType",
    caption: "סוג בעיה",
    valueConverter: (row) => {
      return row.issueType ? ISSUE_TYPE_HEB[row.issueType] : "-";
    },
  },
  {
    field: "issueDescription",
    caption: "תיאור",
  },
  {
    field: "opportunity",
    caption: "פרטי המשימה",
    cell: ({ row }: { row: CoreRow<OpportunityReport>; }) => {
      if (!row.original.opportunity?.title) return "-";
      // @ts-ignore -- change caption
      return (
        <div>
          <Typography>{`${row.original.opportunity?.title} | ${row.original.opportunity ? formatOpportunitySchedule(row.original.opportunity) : ""}`}</Typography>
        </div>
      );
    },
    enableSorting: false,
  },
  {
    field: "createdAt",
    caption: "תאריך הדיווח",
  },
];

export default columns;
